const STORAGE_KEY = 'energy:recently-viewed';

function readHandles() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

function writeHandles(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 20)));
  } catch (e) {
    /* storage unavailable */
  }
}

class RecentlyViewedProducts extends HTMLElement {
  async connectedCallback() {
    const currentHandle = this.dataset.currentHandle;
    if (currentHandle) {
      const list = readHandles().filter((h) => h !== currentHandle);
      list.unshift(currentHandle);
      writeHandles(list);
    }

    const limit = Number(this.dataset.limit) || 8;
    const handles = [...new Set(readHandles())]
      .filter((h) => h !== currentHandle)
      .slice(0, limit);
    if (!handles.length) return;

    const listEl = this.querySelector('[data-recently-viewed-list]');
    // Ask Shopify to render the real product card for each handle (same markup as every other card on the store).
    const cards = await Promise.all(
      handles.map((h) =>
        fetch(`/products/${h}?section_id=product-card-render`)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('.product-card')?.outerHTML || '';
          })
          .catch(() => '')
      )
    );

    const markup = cards.filter(Boolean);
    if (!markup.length) return;
    listEl.innerHTML = markup.join('');
    this.hidden = false;
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
